<template>
    <div v-show="popper_isVisible">
        <nav-programs v-bind:style="styleObject" />
    </div>
</template>

<script>
    import navPrograms from "./navPrograms.vue";
    import popperMixin from "./popperMixin";
    import { responsiveManager } from "Responsive/manager";

    export default {
        components: { navPrograms },
        mixins: [popperMixin],
        data() {
            return {
                popper_popperPlacement: "bottom-start"
            };
        },
        computed: {
            styleObject() {
                if (responsiveManager.globalWidth.value >= 1600) {
                    return {
                        width: "50vw",
                        "max-height": "80vh"
                    };
                }
                return {
                    width: "75vw",
                    "max-height": "80vh"
                };
            }
        },
        methods: {
            async popper_onShow() {
                // awaiting next tick was not doing the trick, so use a timeout instead.
                setTimeout(() => {
                    const selectedProgram = this.$el.querySelector(".pc-selected-program");
                    selectedProgram?.scrollIntoView({ behavior: "auto", block: "nearest" });
                }, 10);
            }
        }
    };
</script>
